import classNames from 'classnames';
import type { HTMLAttributes, ReactNode } from 'react';

import styles from './ExtrasRow.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode;
    className?: string;
    noWrap?: boolean;
}

export function ExtrasRow({ children, className, noWrap = false, ...attributes }: Props) {
    return (
        <div
            {...attributes}
            className={classNames(className, styles.container, { [styles.wrap]: !noWrap })}
        >
            {children}
        </div>
    );
}
